module.exports = __webpack_public_path__ + "static/media/kickoff.ac0944a6.svg";